import React from 'react';
import { Grid, Typography, Chip } from '@mui/material';

export default function MachineInvoice({ machineDetails }) {
  return (
    <Grid container spacing={2} style={{ paddingTop: '30px' }}>
      <Grid item xs={12} className="machineModalView">
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
            <Typography component="h4" variant="h3" sx={{ color: '#fff' }}>
              Machine Invoice
            </Typography>
          </div>
          <Grid container spacing={2} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: 0 }}>
              <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Machine Invoice Number :{' '}
                  </Typography>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                    {machineDetails?.purchaseInvoice?.invoiceNumber ?? 'N.A.'}
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} sx={{ padding: 0 }}>
              <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Machine Invoice Status :{' '}
                  </Typography>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                    {machineDetails?.purchaseInvoice?.status && (
                      <Chip
                        label={
                          machineDetails?.purchaseInvoice?.status === 'Pending'
                            ? 'Pending'
                            : machineDetails?.purchaseInvoice?.status === 'Paid'
                            ? 'Paid'
                            : machineDetails?.purchaseInvoice?.status === 'AwaitingClearance'
                            ? 'Awaiting Clearance'
                            : 'Cancelled'
                        }
                        style={{
                          color: '#fff',
                          fontWeight: '400',
                          backgroundColor:
                            machineDetails?.purchaseInvoice?.status === 'Pending'
                              ? '#ae30c2'
                              : machineDetails?.purchaseInvoice?.status === 'Paid'
                              ? '#30c42b'
                              : machineDetails?.purchaseInvoice?.status === 'AwaitingClearance'
                              ? '#dbc115'
                              : '#d84315'
                        }}
                      />
                    )}
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
}
